import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepGeneralFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepGeneralFormContainer.jsx';

const EditPortfolioStepGeneral = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>Edit {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepGeneralFormContainer portfolioId={portfolioId} slug={slug} />
  </>
);

EditPortfolioStepGeneral.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});
export default requireAuth(withRouterParams(EditPortfolioStepGeneral));
